import { createRouter, createWebHistory } from 'vue-router'
import PosView from '../views/PosView.vue'

const routes = [
  { path: '/:posSlug/:terminalSlug', name: 'terminal', component: PosView },
  { path: '/:terminalSlug', name: 'terminal-unassigned', component: PosView },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
